import { Box, Typography, alpha } from '@mui/material'
import { AccountTree, CellTower, Flag, Shield } from '@mui/icons-material'

import { CLOCK_THEMES } from './MapClock'
import { glassSx } from './overlayStyles'

// Unit types: 0 Command, 1 Regiment, 2 Company, 3 Outpost
const UNIT_TYPES = {
  0: { label: 'Command', Icon: Shield },
  1: { label: 'Regiment', Icon: AccountTree },
  2: { label: 'Company', Icon: Flag },
  3: { label: 'Outpost', Icon: CellTower },
}

// Selected unit, centered at the top of the map. Accent follows the page (live / replay),
// like MapClock, so both overlays on one page belong together.
const MapUnitBadge = ({ unit, mode = 'live', radarView = false }) => {
  if (!unit?.name) return null

  const { accent } = CLOCK_THEMES[mode] || CLOCK_THEMES.live
  const type = UNIT_TYPES[unit.type] || { label: 'Unit', Icon: Shield }
  const { Icon } = type

  const details = [
    type.label,
    unit.type === 3 && unit.number !== undefined && unit.number !== null ? `No. ${unit.number}` : null,
    radarView ? 'Radar view' : null,
  ].filter(Boolean)

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        pointerEvents: 'none',
        userSelect: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        maxWidth: 'max(220px, calc(100% - 560px))',   // stays clear of the clock (left) and panel buttons (right)
        minWidth: 0,
        pl: 0.75,
        pr: 2.25,
        py: 0.75,
        borderRadius: '999px',
        color: '#fff',
        ...glassSx(accent),
      }}
    >
      <Box
        sx={{
          width: 38,
          height: 38,
          flexShrink: 0,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: accent,
          backgroundColor: alpha(accent, 0.10),
          border: `1px solid ${alpha(accent, 0.4)}`,
        }}
      >
        <Icon sx={{ fontSize: '1.25rem' }} />
      </Box>

      <Box minWidth={0}>
        <Typography
          noWrap
          sx={{ fontSize: '1.15rem', fontWeight: 700, lineHeight: 1.15, letterSpacing: '0.02em' }}
        >
          {unit.name}
        </Typography>
        <Typography
          noWrap
          sx={{
            fontSize: '0.66rem',
            fontWeight: 700,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: alpha(accent, 0.85),
          }}
        >
          {details.join(' · ')}
        </Typography>
      </Box>
    </Box>
  )
}

export default MapUnitBadge
